import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IDanhBaSinhVienActionTypes } from "../../action-types/category/IDanhBaSinhVienActionTypes";
import { IDanhBaSinhVienReducer } from "../../reducer-model/category/IDanhBaSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDanhBaSinhVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  displayMode: getDefaultDisplayMode(),
  sinhVienSelectedIds: [],
  dotNhapHoc: 0,
  trangThaiHocs: [0],
  dot: 0,
  doiTuongIds: [],
};
export const danhBaSinhVienReducer = (
  state: IDanhBaSinhVienReducer = iniState,
  action: IDanhBaSinhVienActionTypes,
): IDanhBaSinhVienReducer => {
  switch (action.type) {
    case "DANH_BA_SINH_VIEN_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        sinhVienSelectedIds: [],
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        sinhVienSelectedIds: [],
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        sinhViens: action.payload,
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_SINHVIEN_SELECTED_IDS":
      return {
        ...state,
        sinhVienSelectedIds: action.payload,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_DOI_TUONG":
      return {
        ...state,
        doiTuongIds: action.payload,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_TRANG_THAI_HOC":
      return {
        ...state,
        trangThaiHocs: action.payload,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_DOT_NHAP_HOC":
      return {
        ...state,
        dotNhapHoc: action.payload,
      };
    case "DANH_BA_SINH_VIEN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        sinhVienEditing: action.payload,
        saveStatus: eReducerStatusBase.is_completed,
      };
    case "DANH_BA_SINH_VIEN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        sinhVienEditing: undefined,
      };
    case "DANH_BA_SINH_VIEN_SAVE_START":
      return {
        ...state,
        saveStatus: eReducerStatusBase.is_saving,
      };
    case "DANH_BA_SINH_VIEN_SAVE_SUCCESS":
      return {
        ...state,
        saveStatus: eReducerStatusBase.is_completed,
        isShowEditModal: false,
        sinhVienEditing: undefined,
        sinhViens: state.sinhViens.map((x) =>
          x.id_sv === action.payload.id_sv
            ? {
                ...x,
                cmnd: action.payload.cmnd,
                email: action.payload.email,
                so_tai_khoan: action.payload.so_tai_khoan,
                ma_don_vi_quan_he_ngan_sach:
                  action.payload.ma_don_vi_quan_he_ngan_sach,
                ten_ngan_hang: action.payload.ten_ngan_hang,
                co_quan_cong_tac: action.payload.co_quan_cong_tac,
                ma_so_thue_co_quan: action.payload.ma_so_thue_co_quan,
                dia_chi_co_quan: action.payload.dia_chi_co_quan,
              }
            : x,
        ),
      };
    case "DANH_BA_SINH_VIEN_SAVE_ERROR":
      return {
        ...state,
        saveStatus: eReducerStatusBase.is_completed,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_SEARCH_KEY":
      return {
        ...state,
        searchKey: action.payload,
      };
    case "DANH_BA_SINH_VIEN_ADD_SINHVIEN_TO_LIST": {
      const sv = action.payload as any;
      if (!sv?.id_sv) return state;
      if (state.sinhViens.some((x) => x.id_sv === sv.id_sv)) return state;
      return {
        ...state,
        sinhViens: [sv, ...state.sinhViens],
        status: eReducerStatusBase.is_completed,
      };
    }
    default:
      return state;
  }
};
